module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BZLpYy/tc-custom/9781607056188.jpg?1701244364800",
      "alt": "This image is the cover for the book Field Guide to Fabric Design"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Field Guide to Fabric Design\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A comprehensive, step-by-step resource for fabric design and printing—including tips from top designers.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" If you’ve ever dreamed of showing your designs on fabric, textile aficionado Kim Kight, of popular blog True Up, is here to teach you how. Comprehensive and refreshingly straightforward, this impressive volume features two main parts. "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" First, the Design and Color section explains the basics with step-by-step tutorials on creating repeating patterns both by hand and on the computer. Next, the Printing section guides you through transferring those designs on fabric—whether it's block printing, screen printing, digital printing or licensing to a fabric company—and how to determine the best method for you."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Includes extensive photos and illustrations")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kimberly Kight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kim Kight has been passionate about fabric and fabric design since she got her first sewing machine in 2000.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0